import { z } from "zod";

const envSchema = z.object({
  VITE_APP_ENV: z.enum(["local", "dev", "stg", "prd"]),
  VITE_API_URL: z.string(),
  VITE_API_URL_DATA_EXTRACTOR: z.string(),
  VITE_API_URL_ASK_MARA: z.string(),
  VITE_API_URL_INSIGHTFUL_MARA: z.string(),
  VITE_FIREBASE_API_KEY: z.string(),
  VITE_FIREBASE_AUTH_DOMAIN: z.string(),
  VITE_FIREBASE_PROJECT_ID: z.string(),
  VITE_FIREBASE_STORAGE_BUCKET: z.string(),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string(),
  VITE_FIREBASE_APP_ID: z.string(),
  VITE_MUI_X_LICENSE_KEY: z.string(),
  VITE_DUMMY_COMPANY_ID: z.string(),
  VITE_FIREBASE_USE_EMULATOR: z.stringbool(),
  VITE_DATADOG_APPLICATION_ID: z.string().optional(),
  VITE_DATADOG_CLIENT_TOKEN: z.string().optional(),
  VITE_DATADOG_SITE: z.string().optional(),
  VITE_DATADOG_SERVICE: z.string().optional(),
  VITE_EXTERNAL_SPOTLIGHT_URL: z.string(),
});

export type Env = z.infer<typeof envSchema>;

export function checkEnv(runtimeEnv: Record<string, string | undefined>): Env {
  const cleanedEnv = Object.entries(runtimeEnv).reduce(
    (acc, [key, value]) => {
      acc[key] = value === "" ? undefined : value;
      return acc;
    },
    {} as Record<string, string | undefined>,
  );

  try {
    return envSchema.parse(cleanedEnv);
  } catch (error) {
    if (error instanceof z.ZodError) {
      console.error("❌ Environment validation failed");
      console.error(error.issues);
      throw new Error("Environment validation failed");
    }
    throw error;
  }
}

let _env: Env | undefined;

function getEnv(): Env {
  if (!_env) {
    _env = envSchema.parse(import.meta.env);
  }
  return _env;
}

export const env = new Proxy({} as Env, {
  get(_, prop: keyof Env) {
    return getEnv()[prop];
  },
});
